import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  MissionLifecycleFragmentFragment,
  PublishMissionStaffingPositionMutation,
  UnpublishMissionStaffingPositionMutation,
  FillMissionStaffingPositionMutation,
  MissionStaffingPositionFragmentFragment,
} from "@/gql"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import useRouter from "@/router/useRouter"
import AddExecutionStaffPositionForm from "@/components/missions/AddExecutionStaffPositionForm.vue"
import { DocumentNode } from "graphql"
import { Actions, Action } from "./constant"

type MutationTypes = { [key: string]: Record<string, any> }


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffingPositionActions',
  props: {
    value: null,
    mission: null,
    refetchQueries: null,
    activeStaffPosition: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: string
  mission: MissionLifecycleFragmentFragment
  refetchQueries: RefetchQueryDescription
  activeStaffPosition: MissionStaffingPositionFragmentFragment | null
}





const { mutate } = useMutation()
const { addSuccess, addError } = useNotification()
const { router, routes } = useRouter()

const staffingPositionAction = ref<Action | null>(null)
const showAddProposalStaffRoleModal = ref(false)
const showLinkDialog = ref(false)
const staffingPositionLoading = ref(false)

watch(
  () => props.value,
  (newValue) => {
    if (newValue) {
      onShowStaffingPositionDialog(newValue)
    }
  },
  {
    immediate: true,
  }
)

const onShowStaffingPositionDialog = (action: string) => {
  switch (action) {
    case Actions.Edit:
      showAddProposalStaffRoleModal.value = true
      break

    case Actions.Publish:
    case Actions.Unpublish:
    case Actions.Fill:
      staffingPositionAction.value = action
      break

    case Actions.CopyLink:
      showLinkDialog.value = true
      break

    default:
      addError(`Unknown action: ${action}`)
      break
  }
}

const onClose = () => {
  showLinkDialog.value = false
  showAddProposalStaffRoleModal.value = false
  staffingPositionAction.value = null
  emit("close")
}

const staffingPositionURL = computed(() => {
  return (
    window.location.host +
    router.resolve({
      name: routes.OpportunityDetail,
      params: { id: props.activeStaffPosition?.id },
    }).href
  )
})

const onStaffPositionAction = async (action: Action | null) => {
  if (!action) return

  const mutations: Record<string, DocumentNode> = {
    publish: PublishMissionStaffingPositionMutation,
    unpublish: UnpublishMissionStaffingPositionMutation,
    fill: FillMissionStaffingPositionMutation,
  }
  const mutation = mutations[action]

  if (!mutation) return addError(`Unknown action: ${action}`)

  staffingPositionLoading.value = true

  // Mutate
  const result = await mutate<MutationTypes>({
    mutation: mutation,
    variables: {
      id: props.activeStaffPosition ? props.activeStaffPosition?.prn : 0,
    },
    done: () => {
      staffingPositionLoading.value = false
    },
    refetchQueries: props.refetchQueries,
  })

  if (result && result.data && !result.data[Object.keys(result.data)[0]].error) {
    // No errors
    addSuccess(`Position ${action}ed successfully`)
    staffingPositionAction.value = null
    onClose()
  }
  staffingPositionLoading.value = false
}

return { __sfc: true,props, emit, mutate, addSuccess, addError, router, routes, staffingPositionAction, showAddProposalStaffRoleModal, showLinkDialog, staffingPositionLoading, onShowStaffingPositionDialog, onClose, staffingPositionURL, onStaffPositionAction, AddExecutionStaffPositionForm, Actions }
}

})